import { render, staticRenderFns } from "./PopoverForm.vue?vue&type=template&id=419a79d6&lang=pug"
import script from "./PopoverForm.vue?vue&type=script&lang=js"
export * from "./PopoverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports